import { Asset } from "../../model/viewModel/asset";
import {
  assetIsTransformer,
  transformerHasDisplayedCommittedLoad,
} from "../../utils/committedLoadFunctions";
import CounterBadge from "../CounterBadge";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Feature from "../feature-flag/Feature";

interface CommittedLoadTransformerWarningIconProps {
  isDragging: boolean;
  position: number[];
  asset: Asset;
}

const CommittedLoadTransformerWarningIcon = ({
  isDragging,
  position,
  asset,
}: CommittedLoadTransformerWarningIconProps) => {
  const includeCommittedLoadQuotationSent = useSelector(
    (state: RootState) => state.settings.isIncludeCommittedLoadQuotationSentEnabled,
  );
  return (
    <Feature flag="UseAcceptToConnectDataEnabled">
      {assetIsTransformer(asset) &&
        transformerHasDisplayedCommittedLoad(asset, includeCommittedLoadQuotationSent) &&
        !isDragging && (
          <CounterBadge
            asset={asset}
            value={"!"}
            position={position}
            popup={false}
            badgeClassName={"badge-warning"}
          />
        )}
    </Feature>
  );
};

export default CommittedLoadTransformerWarningIcon;
